<template>
  <span>
    <el-popover v-if="dataList.length > 4"
                placement="right"
                width="400"
                trigger="click">
      <div class="title" v-bind:class="getTitleClass()">{{ getTitle() }}</div>
      <table width="100%"
             cellspacing="0"
             cellpadding="0"
             class="table-more-list">
        <tr v-for="(item, index) in dataList"
            v-show="index >= 4"
            :key="`more-market-${item.id}-${index}`">
          <td width="70%">{{item.name}}</td>
          <td width="30%" align="right">
            <el-button type="danger" size="mini" @click="onRemoveButtonClick(index)">{{ $t('remove') }}</el-button>
          </td>
        </tr>
      </table>
      <el-button slot="reference"
                 :type="getType()"
                 size="mini"
                 class="more-item-button">
        {{ $t('more') }} (<strong>{{ dataList.length - 4 }}</strong>)
      </el-button>
    </el-popover>
  </span>
</template>
<script>
import i18nMessages from '@/translations/Email/ManageEmail/components/PopOverMoreItemComponent.i18n'
export default {
  name: 'PopOverMoreItemComponent',
  i18n: { messages: i18nMessages },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    listType: {
      type: String,
      default: 'market'
    }
  },
  methods: {
    onRemoveButtonClick: function (index) {
      this.$emit('onRemoveItem', index)
    },
    getType: function () {
      if (this.listType === 'agentType') {
        return 'info'
      }

      if (this.listType === 'agent') {
        return 'warning'
      }

      return 'success'
    },
    getTitle: function () {
      if (this.listType === 'agentType') {
        return this.$t('agentTypeList')
      }

      if (this.listType === 'agent') {
        return this.$t('agentList')
      }

      return this.$t('marketList')
    },
    getTitleClass: function () {
      if (this.listType === 'agentType') {
        return { 'title-agent-type': true }
      }

      if (this.listType === 'agent') {
        return { 'title-agent': true }
      }

      return { 'title-market': true }
    }

  }
}
</script>
<style scoped>
  .table-more-list {
    width: 100%;
  }
  .table-more-list td {
    padding: 5px;
    border-bottom: 1px #efeded solid;
  }
  .table-more-list tr:last-child > td {
    border-bottom-width: 0px;
  }
  .title {
    width: 412px;
    height: 31px;
    color: #ffffff;
    vertical-align: middle;
    padding-top: 10px;
    margin-top: -12px;
    padding-left: 12px;
    margin-left: -12px;
    margin-bottom: 10px;
  }
  .title-market {
    background: #67C23A;
  }
  .title-agent-type {
    background: #909399;
  }
  .title-agent {
    background: #E6A23C;
  }
  .button-more {
    border-radius: 25px;
  }
  .more-item-button {
    border-radius: 25px !important;
  }
</style>
